var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id, validationId) {
      pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};



















































































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};





























































pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns\"\u003E\u003Ch2 style=\"margin-top: 20px\"\u003EZeiterfassung\u003C\u002Fh2\u003E\u003Cdiv class=\"bigbox centered\" ng-hide=\"timetracking.success\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cspan\u003EErklärung\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cp\u003ESehr geehrter Beschäftigter,\u003Cbr\u003E\u003Cbr\u003ESie nutzen über Ihren Arbeitgeber den Baustein Verpflegungsmehraufwand. Für die Gewährung der Leistungen ist ein Nachweis Ihrer monatlichen Abwesenheitszeiten erforderlich.\u003Cbr\u003EDer Arbeitgeber kann über die monatliche Entgeltabrechnung nur die Tage ersetzen, welche durch Sie dokumentiert wurden.\u003Cbr\u003E\u003Cbr\u003EBitte tragen Sie hier Ihre persönliche Arbeitnehmer-ID (ValueNetID) ein. Diese haben Sie von Ihrem Arbeitgeber bzw. Ihrem Berater erhalten - nicht zu verwechseln mit Ihrer Personalnummer.\u003Cbr\u003E\u003Cbr\u003EAnspruch haben Sie immer an den Tagen, wo sie sich aus beruflichen Gründen außerhalb der eigenen Wohnung und außerhalb der regelmäßigen Arbeitsstätte aufhalten.\u003Cbr\u003E\u003Cbr\u003EGeben Sie hier jeweils die zeitlichen Daten sowie den \"Zweck der Tätigkeit\" an - Letzteres dient vor allem der Zuordnung und Prüfung in Ihrem Unternehmen.\u003Cbr\u003E\u003Cbr\u003EBitte beachten Sie, das Sie diese Daten regelmäßig einsenden.\u003Cbr\u003EZum 15. des laufenden Monats werden alle erfassten Daten zur Abrechnung an den Arbeitgeber übermittelt.\u003Cbr\u003ESpäter angegebene Daten werden erst im nächsten Abrechnungsmonat Berücksichtigung finden.\u003Cbr\u003E\u003Cbr\u003Ebei Fragen wenden Sie sich einfach an" + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp)) + "\u003Ca href=\"mailto:verwaltung@valuenet.de\"\u003Everwaltung@valuenet.de\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bigbox centered\" ng-hide=\"timetracking.success\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cspan\u003EAllgemeine Daten\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\" overlay=\"timetracking.working\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-6\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "timetracking.employee.empid","title": "ValueNet ID","required": pug.escape(true),"validationMessages": {"required":"Geben Sie Ihre ValueNet ID ein"},"attributes": {"tabindex":1}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-6\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "timetracking.employee.email","title": "E-Mail Adresse","type": "email","required": pug.escape(true),"validationMessages": {"required":"Bitte geben Sie eine E-Mail Adresse an","email":"Bitte geben Sie eine gültige E-Mail Adresse an"},"attributes": {"tabindex":2}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-6\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "timetracking.employee.firstname","title": "Vorname","required": pug.escape(true),"validationMessages": {"required":"Geben Sie einen Vornamen an"},"attributes": {"tabindex":3}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-6\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "timetracking.employee.lastname","title": "Nachname","required": pug.escape(true),"validationMessages": {"required":"Geben Sie einen Nachnamen an"},"attributes": {"tabindex":4}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bigbox centered\" style=\"overflow:visible\" ng-hide=\"timetracking.success\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cspan\u003EZeiterfassung\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\" overlay=\"timetracking.working\"\u003E\u003Cdiv ng-repeat=\"entry in timetracking.data track by $index\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns xsmall-12 small-6 medium-3\"\u003E\u003Cdatepicker date-format=\"dd.MM.yyyy\" selector=\"dateInput\" date-refocus=\"false\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "entry.date","title": "Datum","id": "entry.date{{$index}}","validationId": "\"entry.date\" + $index","required": pug.escape(true),"attributes": {"vn-date-helper":"true","ng-model-options":"{allowInvalid: true}","ng-pattern":"\u002F^(0?[1-9]|[12][0-9]|3[01])\\.([0]?[0-9]|1[0-2])\\.\\d{4}$\u002F","tabindex":"{{ $index * 5 + 5 }}"},"fieldHtmlClass": "dateInput","validationMessages": {"required":"Bitte Datum angeben","pattern":"Bitte Datum im Format tt.mm.jjjj eingeben"}}
});
pug_html = pug_html + "\u003C\u002Fdatepicker\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-6 medium-3\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "entry.start","title": "Uhrzeit ab","id": "entry.start{{$index}}","validationId": "\"entry.start\" + $index","required": pug.escape(true),"attributes": {"vn-time-helper":true,"ng-model-options":"{allowInvalid: true}","ng-pattern":"\u002F^([01]?[1-9]|2[0-4]):([0-5]?[0-9])$\u002F","tabindex":"{{ $index * 5 + 6 }}"},"validationMessages": {"required":"Bitte Uhrzeit ab angeben","pattern":"Bitte Uhrzeit ab im Format hh:mm eingeben"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-6 medium-3\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "entry.end","title": "Uhrzeit an","id": "entry.end{{$index}}","validationId": "\"entry.end\" + $index","required": pug.escape(true),"attributes": {"vn-time-helper":true,"ng-model-options":"{allowInvalid: true}","ng-pattern":"\u002F^([01]?[1-9]|2[0-4]):([0-5]?[0-9])$\u002F","tabindex":"{{ $index * 5 + 7 }}"},"validationMessages": {"required":"Bitte Uhrzeit an angeben","pattern":"Bitte Uhrzeit an im Format hh:mm eingeben"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-6 medium-3\"\u003E\u003Clabel\u003EDauer\u003C\u002Flabel\u003E\u003Cstrong\u003E{{ timetracking.getDuration(entry.start, entry.end) }}\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns xsmall-12 small-6\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "entry.reference","title": "Zweck der Tätigkeit","id": "entry.reference{{$index}}","validationId": "\"entry.reference\" + $index","required": pug.escape(true),"validationMessages": {"required":"Geben Sie einen Zweck der Tätigkeit \u002F Baustelle an"},"attributes": {"tabindex":"{{ $index * 5 + 8 }}"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-6 no-label\"\u003E\u003Cbutton class=\"button button-primary right\" type=\"button\" ng-click=\"timetracking.data.splice( $index, 1 )\" tabindex=\"{{ $index * 5 + 9 }}\"\u003EZeile löschen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Chr\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns\"\u003E\u003Cbutton class=\"button button-primary left\" type=\"button\" ng-disabled=\"timetracking.working\" ng-click=\"timetracking.data.push({})\" tabindex=\"{{ $index * 5 + 10 }}\"\u003EWeitere Zeile hinzufügen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bigbox centered\" style=\"margin-bottom: 120px;\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cspan\u003E{{ timetracking.success && 'Erfolg' || 'Absenden' }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cp class=\"small-attention\"\u003EIch habe die\u003Ca href=\"\u002Fdatenschutz\" target=\"_blank\"\u003E&nbsp;Datenschutzerklärung&nbsp;\u003C\u002Fa\u003Ezur Kenntnis genommen und bestätige dies mit dem Absenden der Nachricht. Ich stimme zu, dass meine Angaben und Daten zur Beantwortung meiner Anfrage elektronisch erhoben und gespeichert werden. Die Einwilligung kann ich jederzeit für die Zukunft widerrufen.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cspan class=\"error\" ng-show=\"timetracking.error\" ng-click=\"timetracking.error = false\"\u003EIhre Eingaben konnten nicht gespeichert werden.\u003C\u002Fspan\u003E\u003Cdiv class=\"row\" ng-hide=\"timetracking.success\"\u003E\u003Cdiv class=\"columns\"\u003E\u003Cbutton class=\"button button-primary right\" type=\"submit\" form=\"timetrackingForm\" value=\"Speichern\" ng-disabled=\"!timetrackingForm.$valid || timetracking.working\"\u003ESpeichern\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"timetracking.success\"\u003E\u003Cdiv class=\"columns\"\u003E\u003Cp\u003EVielen Dank! Ihre Daten wurden erfolgreich übermittelt. Sie erhalten in\nKürze eine Bestätigungs-E-Mail.\n\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"class": "form-padding","name": "timetrackingForm","id": "timetrackingForm","ng-submit": "timetracking.save()"}
});
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;